import { Realtime } from '@doxyme/realtime';
import { getGrowthBookConfigLoader } from '@doxyme/config';

import { getResolvedFrontendGraphqlUrls } from '../../services/resolveFrontendGraphqlUrls';

const realtimeBackendUrl = getResolvedFrontendGraphqlUrls().graphqlUrl;
const getVendorLogLevel = () =>
  getGrowthBookConfigLoader().getOptional('realtime_vendor_log_level') as
    | number
    | undefined;

export const realtimeInstance = new Realtime(
  realtimeBackendUrl,
  getVendorLogLevel,
);
